import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/layout/Layout';

import HomePage from './components/pages/HomePage';
import LandingPage from './components/pages/LandingPage';
import AboutPage from './components/pages/AboutPage';
import DoctorPage from './components/pages/DoctorPage';
import ServicesPage from './components/pages/ServicesPage';
import ServiceDetailPage from './components/pages/ServiceDetailPage';
import ServiceSubPage from './components/pages/ServiceSubPage';
import PatientCenterPage from './components/pages/PatientCenterPage';
import ContactPage from './components/pages/ContactPage';
import LocationPage from './components/pages/LocationPage';
import BookPage from './components/pages/BookPage';
import BlogPage from './components/pages/BlogPage';
import NotFoundPage from './components/pages/NotFoundPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/"                             element={<HomePage />} />

          {/* ── Doctors ───────────────────────────────── */}
          <Route path="/doctors"                      element={<LandingPage pageKey="doctors" />} />
          <Route path="/doctors/:doctorSlug"          element={<DoctorPage />} />
          <Route path="/about"                        element={<LandingPage pageKey="doctors" />} />
          <Route path="/about/:doctorSlug"            element={<DoctorPage />} />

          {/* ── Services ───────────────────────────────── */}
          <Route path="/services"                     element={<LandingPage pageKey="services" />} />
          <Route path="/services/:serviceSlug"        element={<ServiceDetailPage />} />
          <Route path="/services/:serviceSlug/:subSlug" element={<ServiceSubPage />} />

          {/* ── Patient Center ─────────────────────────── */}
          <Route path="/patient-center"               element={<LandingPage pageKey="patient-center" />} />
          <Route path="/patient-center/:section"      element={<PatientCenterPage />} />
          <Route path="/patient-info"                 element={<LandingPage pageKey="patient-center" />} />
          <Route path="/patient-info/:section"        element={<PatientCenterPage />} />

          {/* ── Contact ────────────────────────────────── */}
          <Route path="/contact"                      element={<LandingPage pageKey="contact" />} />
          <Route path="/contact/location" element={<LocationPage />} />
          <Route path="/contact/:section"             element={<ContactPage />} />
          <Route path="/book-appointment"             element={<BookPage />} />

          {/* Blog */}
          <Route path="/blog"                         element={<BlogPage />} />

          {/* 404 */}
          <Route path="*"                             element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </>
  );
}
